import { Button, Input } from "@nextui-org/react";
import { useState } from "react";
import { Link, Navigate, useSearchParams, useNavigate } from "react-router-dom";
import fetchWrapper from "../utils/fetch";
import { useAuth } from "../contexts/auth-context";
import { toast } from "react-toastify";

export default function LoginPage() {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [{ isAuthenticated, status }, authDispatch] = useAuth();
  const [searchParams] = useSearchParams();
  const resetRequested = searchParams.get("reset") === "requested";
  const navigate = useNavigate();

  const isLoading = status === "loading";

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const updates = Object.fromEntries(formData);
    
    authDispatch({ type: "start login" });
    try {
      // Login and get token
      const response = await fetchWrapper.post("/login", updates);
      
      // Store token and update login state
      localStorage.setItem("access_token", response.access_token);
      authDispatch({ type: "finished login", payload: response.access_token });
      
      // Fetch profile and update state
      const profileData = await fetchWrapper.get("/profile");
      authDispatch({ type: "finished profile", payload: profileData });
      
      // Navigate after all state updates are complete
      navigate("/");
    } catch (err) {
      if (err?.detail === "نام کاربری یا رمز عبور درست نیست.") {
        toast.error("نام کاربری یا رمز عبور درست نیست.");
      } else {
        toast.error(err?.detail || "خطا در ورود");
      }
      authDispatch({ type: "failed login", payload: err });
    }
  };

  return (
    <div className="flex items-center justify-center bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6">
        <div>
          <h2 className="text-center text-3xl font-extrabold text-gray-900">
            ورود به حساب کاربری
          </h2>
          {resetRequested && (
            <p className="mt-2 text-center text-sm text-green-600">
              لینک بازیابی رمز عبور به ایمیل شما ارسال شد
            </p>
          )}
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Input
              name="username"
              type="text"
              label="نام کاربری"
              required
              className="mb-4"
            />
          </div>
          <div>
            <Input
              name="password"
              type={passwordVisible ? "text" : "password"}
              label="رمز عبور"
              required
              className="mb-4"
              endContent={
                <button
                  className="focus:outline-none"
                  type="button"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                >
                  {passwordVisible ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  )}
                </button>
              }
            />
          </div>

          <div>
            <Button
              type="submit"
              color="primary"
              className="w-full"
              isLoading={isLoading}
            >
              ورود
            </Button>
          </div>
        </form>

        <div className="flex flex-col items-center space-y-2">
          <Link to="/signup" className="text-primary hover:text-primary-dark">
            ثبت نام نکرده‌اید؟
          </Link>
          <Link to="/forgot-password" className="text-sm text-gray-600 hover:text-gray-900">
            رمز عبور خود را فراموش کرده‌اید؟
          </Link>
        </div>
      </div>
    </div>
  );
}
